import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CreatePricingDialogContentComponent } from './create-pricing-dialog-content/create-pricing-dialog-content.component';

@Component({
  selector: 'app-create-pricing-dialog',
  template: ''
})
export class CreatePricingDialogComponent implements OnInit
{
  private modal: NgbModalRef | null = null
  private customerId: string
  
  constructor(
    public modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.customerId = this.activatedRoute.parent.parent.snapshot.params.key;
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    event.preventDefault();
    if (this.modal) this.modal.close()
  }

  ngAfterViewInit() {
    if (this.modalService.hasOpenModals()) return
    this.openDialog();
  }

  openDialog(): void {
    if (this.modal) {
      this.modal.close()
    }
    
    this.modal = this.modalService.open(
      CreatePricingDialogContentComponent,
      { centered: true, size: 'xxl', backdrop: 'static' }
    )

    this.modal.componentInstance.customerId = this.customerId;

    this.modal.result.then(toDashboard => {
      if (toDashboard) window.history.go(-2)
      else this.router.navigate(['../'], { relativeTo: this.activatedRoute })
    }, (reason) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute })
    })
  }

  ngOnDestroy() {
    if (this.modal) {
      this.modal.close()
    }
  }
}
